
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company-profile-product",
      function () {
        return require("private-next-pages/company-profile-product.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company-profile-product"])
      });
    }
  